export * from './money.js';
export * from './schemas.js';

/**
 * Order status transitions.
 *
 * Modelled as an explicit adjacency map rather than a chain of `if` statements
 * scattered across route handlers. Two things fall out of this for free:
 * the API can reject an illegal transition with a precise message, and the
 * admin UI can render exactly the buttons that are legal for the current state.
 */
export const ORDER_TRANSITIONS = {
  pending_payment: ['paid', 'cancelled'],
  paid: ['fulfilled', 'refunded', 'cancelled'],
  fulfilled: ['refunded'],
  cancelled: [],
  refunded: [],
} as const;

export type OrderStatus = keyof typeof ORDER_TRANSITIONS;

export function canTransition(from: OrderStatus, to: OrderStatus): boolean {
  return (ORDER_TRANSITIONS[from] as readonly string[]).includes(to);
}

export function nextOrderStatuses(from: OrderStatus): OrderStatus[] {
  return [...ORDER_TRANSITIONS[from]] as OrderStatus[];
}

/** Statuses that should no longer hold reserved inventory. */
export const RELEASES_STOCK: readonly OrderStatus[] = ['cancelled', 'refunded'];

/** Statuses that count towards revenue reporting. */
export const REVENUE_STATUSES: readonly OrderStatus[] = ['paid', 'fulfilled'];
